import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getElectricMeterStatistics } from '@/service/operate/energyManagement';
export default function useTotalData(params) {
  var totalData = ref({
    areaElectricMeterList: [],
    total_electric_fee: 0,
    total_electric_value: 0
  });
  // 获取能源统计和各耗电区域对比数据
  var getElectricTotalAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getElectricMeterStatistics(params.value);
          case 2:
            data = _context.sent;
            totalData.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getElectricTotalAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var summaryData = computed(function () {
    return [{
      num: totalData.value.total_electric_value,
      desc: '总耗电量/度'
    }
    // { num: totalData.value.total_electric_fee, desc: '电费/元' }
    ];
  });
  return [totalData, summaryData, getElectricTotalAsync];
}